<header role="banner">
  <cigna-header
    [authenticated]="secure"
    [resourceLibraryApp]="true"
    [logoLinkInternal]="false"
    [logoLink]="path"
  ></cigna-header>
</header>

<cigna-video-dialog-loader></cigna-video-dialog-loader>
<cigna-resources-modal></cigna-resources-modal>
